<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'MenuLegacyMarker'
 * FIGMA: ''
 */
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { AppTooltip } from '@UI/Tooltips/AppTooltip'
import { AppIcon } from '@UI/Icons/AppIcon'

defineOptions({
  name: 'MenuLegacyMarker',
})

const LEGACY_MARKER_TOOLTIP = 'Legacy page, need to move to new Admin Panel'
</script>

<template>
  <span class="legacy-marker">
    <AppTooltip
      :text="LEGACY_MARKER_TOOLTIP"
      placement="right"
      size="small"
    >
      <AppIcon
        :icon="faTriangleExclamation"
        size="small"
        color="amber-400"
      />
    </AppTooltip>
  </span>
</template>

<style scoped lang="scss" src="@scss/components/UI/Menus/SidebarMenu/components/MenuLegacyMarker.scss" />
